import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./GalleryHero.module.css";

const GalleryHero = () => {
  const [current, setCurrent] = useState(0);

  // Furniture series-based slides
  const gallerySlides = [
    {
      title: "Bar Stool Series",
      subtitle:
        "Modern bar stools for commercial spaces, perfect for cafes and restaurants",
      models: "13 Models",
      background:
        "https://images.unsplash.com/photo-1519710164239-da123dc03ef4?auto=format&fit=crop&w=1800&q=80",
    },
    {
      title: "Cafeteria Series",
      subtitle:
        "Durable and stylish furniture solutions for high-traffic cafeteria environments",
      models: "14 Models",
      background:
        "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1800&q=80",
    },
    {
      title: "Cyber Series",
      subtitle:
        "Contemporary designs with tech-inspired aesthetics for modern offices",
      models: "9 Models",
      background:
        "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1800&q=80",
    },
    {
      title: "Director Series",
      subtitle:
        "Executive furniture for leadership spaces with premium materials",
      models: "10 Models",
      background:
        "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1800&q=80",
    },
    {
      title: "Executive Series",
      subtitle: "Premium executive furniture for corporate leadership offices",
      models: "14 Models",
      background:
        "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1800&q=80",
    },
  ];

  // Auto-rotate slides
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % gallerySlides.length);
    }, 50000);
    return () => clearInterval(timer);
  }, [gallerySlides.length]);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % gallerySlides.length);
  };

  const prevSlide = () => {
    setCurrent(
      (prev) => (prev - 1 + gallerySlides.length) % gallerySlides.length
    );
  };

  return (
    <div className={styles.heroSection}>
      <AnimatePresence mode="wait">
        <motion.div
          key={current}
          className={styles.heroSlide}
          transition={{ duration: 1.2, ease: "easeInOut" }}
          style={{
            backgroundImage: `linear-gradient(rgba(20, 30, 48, 0.7), rgba(36, 59, 85, 0.7)), url(${gallerySlides[current]?.background})`,
          }}
        >
          <div className={styles.heroContent}>
            <motion.h1
              className={styles.heroTitle}
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.8 }}
            >
              {gallerySlides[current].title}
            </motion.h1>
            <motion.p
              className={styles.heroSubtitle}
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              {gallerySlides[current].subtitle}
            </motion.p>
            {/* <motion.div
              className={styles.heroMeta}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.7, duration: 0.8 }}
            >
              <span className={styles.modelCount}>
                📦 {gallerySlides[current].models}
              </span>
            </motion.div> */}
            {/* <motion.div
              className={styles.heroCta}
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.9, duration: 0.8 }}
            >
              <button className={styles.ctaButton}>View Series</button>
            </motion.div> */}
          </div>
        </motion.div>
      </AnimatePresence>

      {/* Navigation Arrows */}
      <button
        className={`${styles.navButton} ${styles.prevButton}`}
        onClick={prevSlide}
      >
        ‹
      </button>
      <button
        className={`${styles.navButton} ${styles.nextButton}`}
        onClick={nextSlide}
      >
        ›
      </button>

      {/* Slide Indicators */}
      {/* <div className={styles.slideIndicators}>
        {gallerySlides.map((_, index) => (
          <button
            key={index}
            className={`${styles.indicator} ${
              index === current ? styles.activeIndicator : ""
            }`}
            onClick={() => setCurrent(index)}
          />
        ))}
      </div> */}

      {/* Scroll Indicator */}
      {/* <div className={styles.scrollIndicator}>
        <div className={styles.scrollArrow}></div>
      </div> */}
    </div>
  );
};

export default GalleryHero;
